import { gql } from '@apollo/client/core';

export const CREATE_SENDBIRD_CHANNEL = gql`
  mutation CreateSendbirdChannel($accountId: UUID!, $message: String, $session: String) {
    createSendbirdChannel(accountId: $accountId, message: $message, session: $session) {
      channel {
        channelUrl
        members {
          userId
          nickname
        }
      }
    }
  }
`;
